<ng-container *ngIf="currentListViewState" ntapDynamicFormProvider>
    <ntap-view-window target="globalDialog"></ntap-view-window>
    <ng-container ntapFilterViewProvider [viewName]="currentListViewName" [viewState]="currentListViewStateFilter">
        <ng-container ntapListViewProvider [viewName]="currentListViewName" [viewState]="currentListViewState">
            <ntap-dynamic [compId]="INIT_COMP_ID"></ntap-dynamic>
        </ng-container>
    </ng-container>
</ng-container>